import auth from '@groovepages/gd-lib/auth';

export default {
  methods: {
    goToUpgradePage() {
      let user = auth.authenticatedUser();
      let url = window.gdEnv[`UPGRADE_URL_${user?.metadata?.region?.toUpperCase()}`] || window.gdEnv[`UPGRADE_URL`];
      window.open(url, '_blank');
    },
  },
};
